export default "__VITE_ASSET__c4723347__"